export default {"src":"/_next/static/media/meditation.a144ed63.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};